/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalSearchItemDto } from './GlobalSearchItemDto';
import {
    GlobalSearchItemDtoFromJSON,
    GlobalSearchItemDtoFromJSONTyped,
    GlobalSearchItemDtoToJSON,
    GlobalSearchItemDtoToJSONTyped,
} from './GlobalSearchItemDto';

/**
 * 
 * @export
 * @interface GlobalSearchGroupDto
 */
export interface GlobalSearchGroupDto {
    /**
     * Type du groupe : client | contrat | devis | simulation | note | contratGroupe
     * @type {string}
     * @memberof GlobalSearchGroupDto
     */
    type: string;
    /**
     * Nombre total de résultats pour ce type (peut dépasser items.length)
     * @type {number}
     * @memberof GlobalSearchGroupDto
     */
    totalCount: number;
    /**
     * 
     * @type {Array<GlobalSearchItemDto>}
     * @memberof GlobalSearchGroupDto
     */
    items: Array<GlobalSearchItemDto>;
}

/**
 * Check if a given object implements the GlobalSearchGroupDto interface.
 */
export function instanceOfGlobalSearchGroupDto(value: object): value is GlobalSearchGroupDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GlobalSearchGroupDtoFromJSON(json: any): GlobalSearchGroupDto {
    return GlobalSearchGroupDtoFromJSONTyped(json, false);
}

export function GlobalSearchGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(GlobalSearchItemDtoFromJSON)),
    };
}

export function GlobalSearchGroupDtoToJSON(json: any): GlobalSearchGroupDto {
    return GlobalSearchGroupDtoToJSONTyped(json, false);
}

export function GlobalSearchGroupDtoToJSONTyped(value?: GlobalSearchGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(GlobalSearchItemDtoToJSON)),
    };
}

